import { 
  apiService, 
  MentionDto, 
  MentionFeedbackDto, 
  CreateMentionFeedbackDto 
} from './api';

export class MentionService {
  /**
   * Get all mentions for the account (across all monitored identities)
   */
  async getAllMentions(token: string, page: number = 1, pageSize: number = 20): Promise<MentionDto[]> {
    return apiService.getAllAccountMentions(token, page, pageSize);
  }

  /**
   * Get mentions for a specific monitored identity
   */
  async getIdentityMentions(identityId: string, token: string, page: number = 1, pageSize: number = 20): Promise<MentionDto[]> {
    return apiService.getMonitoredIdentityMentions(token, identityId, page, pageSize);
  }

  /**
   * Provide feedback on a mention
   */
  async provideFeedback(mentionId: number, feedback: CreateMentionFeedbackDto, token: string): Promise<MentionFeedbackDto> {
    return apiService.provideMentionFeedback(mentionId, feedback, token);
  }

  /**
   * Get existing feedback for a mention
   */
  async getFeedback(mentionId: number, token: string): Promise<MentionFeedbackDto | null> {
    return apiService.getMentionFeedback(mentionId, token);
  }

  /**
   * Get user's feedback history
   */
  async getFeedbackHistory(token: string, page: number = 1, pageSize: number = 20): Promise<MentionFeedbackDto[]> {
    return apiService.getMentionsFeedbackHistory(token, page, pageSize);
  }

  /**
   * Delete feedback for a mention
   */
  async deleteFeedback(mentionId: number, token: string): Promise<void> {
    return apiService.deleteMentionFeedback(mentionId, token);
  }
}

export const mentionService = new MentionService();